import React from 'react';

export default function Url() {
  return (
    <React.Fragment>
      It's a Url!
    </React.Fragment>
  );
}
